import type { FaireProductEntity } from "../../entity_types/product";

export const p_r4x7ahwmrk: FaireProductEntity = {
  token: "p_r4x7ahwmrk",
  type: "product",
  name: "LM-BN-1005 LULU MAC PATCH BEANIE BEIGE",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/1cbbb0a72b118405d4a4cf49c04f921bb20780e0b7dc6d0db78121510265ed74.jpeg",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "Whether it’s for function or style, hair clips are a fun accessory for everyday use. Check out our variety of colors and sizes! \n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:57.808Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
